/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://rc6yi2aqrvgq7eudhh5zmezage.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gs5l5usm3vdmbongaqwfxehs4y",
    "aws_cognito_identity_pool_id": "eu-west-2:23ff744c-d535-4556-9447-c66f6edaf58a",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_YJJAZqqLc",
    "aws_user_pools_web_client_id": "78vnlluokh25rfmjvt8q9oqr6a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "stagestars-storage-4ab9aa5f133241-main",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
